// extracted by mini-css-extract-plugin
export default {"container":"Report-module__container__LspdQ","containerWhite":"Report-module__containerWhite__uJqql","fold":"Report-module__fold__8yXD8"};